export const testimonials = {
  testimonialsPageTitle: "Wenners se getuienisse — Randrush",
  testimonialsPageDescription:
    "Ontdek die stories van ons regte wenners. Getuienisvideo's van spelers wat by Randrush gewen het.",
  testimonialsTitle: "Wenners se getuienisse",
  testimonialsSubtitle: "Regte stories van ons wenners",
  testimonialsFilterLabel: "Filter getuienisse",
  testimonialsFilter_all: "Alles",
  testimonialsFilter_horizontal: "Horisontaal",
  testimonialsFilter_vertical: "Vertikaal",
  testimonialsEmpty: "Nog geen getuienisse beskikbaar nie",
  testimonialsPaginationLabel: "Getuienisse-bladsywering",
  testimonialsPrevPage: "Vorige bladsy",
  testimonialsNextPage: "Volgende bladsy",
  testimonialsPage: "Bladsy",

  stickyRegisterTitle: "Registreer en wen!",
  stickyRegisterSubtitle: "Skep jou gratis rekening en begin nou speel",
  stickyRegisterAlreadyHaveAccount: "Het jy reeds 'n rekening?",
  stickyRegisterLogin: "Teken in",
};
